
import * as Sentry from '@sentry/react';

let sentryInitialized = false;

export const initSentry = () => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;

  if (dsn && !sentryInitialized) {
    Sentry.init({
      dsn: dsn,
      environment: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development',
      integrations: [
        Sentry.browserTracingIntegration(),
      ],
      tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
      beforeSend(event, hint) {
        // Filter out certain errors if needed
        return event;
      },
    });
    sentryInitialized = true;
    console.log('Sentry initialized');
  }
};

export default initSentry;
